export const SALES_EXTENSION_CHANNEL = 'hubspot-sales-extension';
export const SALES_NOTIFICATION_RECEIVED_MESSAGE = 'notificationReceived';